import $ from "jquery";
import App from "../src/App";
import { Swiper } from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/scss";
import "swiper/scss/navigation";
import app from "../src/App";

$(document).ready(function () {
  let lightboxSwiper;
  let currentLoadCount;
  let loadMoreIncrement;
  let totalGalleryItems = 0;
  let allGalleryItems = [];

  function initLightboxSwiper() {
    if (lightboxSwiper) lightboxSwiper.destroy();
    lightboxSwiper = new Swiper(".lightbox__swiper", {
      modules: [Navigation],
      loop: true,
      speed: 1200,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    return lightboxSwiper;
  }

  // Initialize gallery
  function initGallery() {
    const $gallery = $(".gallery");
    currentLoadCount = parseInt($gallery.data("initial-load"));
    loadMoreIncrement = parseInt($gallery.data("load-more-increment"));

    // Get total number of items from PHP-generated lightbox
    totalGalleryItems = $(".lightbox__swiper .swiper-slide").length;

    // Store all gallery items data from lightbox
    allGalleryItems = [];
    $(".lightbox__swiper .swiper-slide").each(function (index) {
      const $slide = $(this);
      const imgSrc = $slide.find("img").attr("src");
      const imgAlt = $slide.find("img").attr("alt");
      const caption = $slide.find(".lightbox-caption").text();

      allGalleryItems.push({
        index: index,
        html: `
          <div class="gallery-grid-item" data-lightbox-index="${index}">
            <img src="${imgSrc}"
                 alt="${imgAlt}"
                 class="gallery-img"
                 loading="lazy"
                 data-lightbox-src="${imgSrc}">
            ${caption ? `<div class="lightbox-caption type--h3 color--blue">${caption}</div>` : ""}
          </div>
        `,
      });
    });

    // Initialize Swiper
    lightboxSwiper = initLightboxSwiper();

    // Initial load more button state
    updateLoadMoreButton();
  }

  // Update load more button visibility
  function updateLoadMoreButton() {
    const $loadMoreContainer = $(".gallery-load-more");
    const currentlyDisplayed = $(".gallery-grid .gallery-grid-item").length;

    console.log(`Currently displayed: ${currentlyDisplayed}, Total items: ${totalGalleryItems}`);

    if (currentlyDisplayed >= totalGalleryItems) {
      $loadMoreContainer.hide();
    } else {
      $loadMoreContainer.show();
    }
  }

  // Load more images
  function loadMoreImages() {
    const $button = $("#load-more-gallery");
    const $status = $(".gallery-load-status");
    const $galleryGrid = $(".gallery-grid");

    $button.prop("disabled", true);
    $status.show();

    setTimeout(() => {
      const currentlyDisplayed = $(".gallery-grid .gallery-grid-item").length;
      const remainingItems = totalGalleryItems - currentlyDisplayed;
      const itemsToLoad = Math.min(loadMoreIncrement, remainingItems);

      const nextBatch = allGalleryItems.slice(currentlyDisplayed, currentlyDisplayed + itemsToLoad);

      // Append new items
      nextBatch.forEach((item) => {
        $galleryGrid.append(item.html);
      });

      // Rebind click handlers for all items
      $(".gallery-grid-item").off("click").on("click", handleGalleryItemClick);

      updateLoadMoreButton();
      $status.hide();
      $button.prop("disabled", false);
    }, 300);
  }

  function handleGalleryItemClick() {
    const index = parseInt($(this).data("lightbox-index"));
    app.scrollBlock("gallery");

    // Reinitialize Swiper
    lightboxSwiper = initLightboxSwiper();

    setTimeout(() => {
      lightboxSwiper.slideToLoop(index);
      $(".lightbox").css("display", "flex");
    }, 50);
  }

  // Initialize the gallery
  initGallery();

  // Event handlers
  $("#load-more-gallery").on("click", loadMoreImages);
  $(".gallery-grid-item").on("click", handleGalleryItemClick);

  // Close lightbox
  $(".lightbox__close, .lightbox").on("click", function (e) {
    if ($(e.target).closest(".lightbox__close").length || $(e.target).is(".lightbox")) {
      $(".lightbox").css("display", "none");
      app.scrollUnblock("gallery");
    }
  });

  // Keyboard navigation
  $(document).on("keydown", function (e) {
    if ($(".lightbox").css("display") === "flex") {
      if (e.key === "Escape") {
        $(".lightbox").css("display", "none");
      } else if (e.key === "ArrowRight") {
        lightboxSwiper.slideNext();
      } else if (e.key === "ArrowLeft") {
        lightboxSwiper.slidePrev();
      }
    }
  });
});
